import { Observable } from 'rxjs';

import { HttpClient, HttpParams } from '@angular/common/http';

import { CxsBasket, UpdateBasketRequest } from '../model';

export const putBasket = (
    httpClient: HttpClient,
    basketUpdate: UpdateBasketRequest,
    customerEmail?: string
): Observable<CxsBasket> => {
    let params: HttpParams = new HttpParams();
    if (customerEmail) {
        params = params.set('customerEmail', customerEmail);
    }

    return httpClient.put<CxsBasket>(`orders-ms/basket/${basketUpdate.basketId}`, basketUpdate, { params });
};
